
<template>
  <div class="unit_upload">

    <div >
     
  </div>

<section
              class="w-full text-center mt-10"
              v-if="isSaving"
            >

              <div class="progress-circle__container">
                <span class="progress-circle__percent font-bold text-lg"
                  >{{ completedPercentage }}%</span
                >

                <svg
                  class="progress-circle"
                  viewBox="0 0 106 106"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Page-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g
                      id="ProgressBar"
                      transform="translate(-17.000000, -17.000000)"
                    >
                      <circle
                        id="Oval"
                        stroke="#949494"
                        stroke-width="7"
                        fill-rule="nonzero"
                        cx="70"
                        cy="70"
                        r="50"
                      ></circle>
                      <path
                        class="progress-circle__path"
                        d="M70,120 C97.6142375,120 120,97.6142375 120,70 C120,42.3857625 97.6142375,20 70,20 C42.3857625,20 20,42.3857625 20,70 C20,97.6142375 42.3857625,120 70,120 Z"
                        id="Oval-Copy"
                        stroke="#1F254A"
                        stroke-width="5"
                        :stroke-dasharray="circle"
                        fill-rule="nonzero"
                        transform="translate(70.000000, 70.000000) rotate(-125.000000) translate(-70.000000, -70.000000) "
                      ></path>
                    </g>
                  </g>
                </svg>
              </div>
              <p>Uploading file</p>
            </section>

                <a class="button-text right text-red-700" v-if="isComplete || isSuccess" v-on:click="clear()">
          <i class="icon fas fa-trash-alt"/> Replace file
      </a>

      <!--UPLOAD-->
       <form enctype="multipart/form-data" novalidate  v-if="isInitial" v-on:click="openBrowse()">
        <div class="grid grid-cols-1 space-y-3">
                <label class="text-sm font-bold text-gray-600 tracking-wide"
                  >Attach Document
                  
                   <a class="button-text right text-orange-700" v-if="isInitial || isSaving" v-on:click="openBrowse()">
          <i class="icon fas fa-search"/> Browse for file
      </a>
                  
                  </label
                >
                <div class=" w-full">
                  <label
                    class="
                      flex flex-col
                      rounded-lg
                      border-4 border-dashed
                      w-full
                      h-60
                      p-10
                      group
                      text-center
                      cursor-pointer
                    "
                  >
                    <div
                      class="
                        h-full
                        w-full
                        text-center
                        flex flex-col
                        items-center
                        justify-center
                        items-center
                      "
                    >
                      <div class="flex flex-auto max-h-48 w-2/5 mx-auto -mt-10">
                        <img
                          class="has-mask h-36 mx-auto p-2 mt-2"
                          src="/static/images/empty/document.png"
                          alt="Add document resource"
                        />
                      </div>
                      <p class="pointer-none text-gray-500">
                        <span class="text-sm">Click to select</span> a file from
                        your computer
                      </p>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      v-on:change="handleFileUpload()"
                      ref="file"
                    />
                  </label>
                </div>


              <p class="text-sm text-gray-400">
                <span>File types: pdf, text, image</span>
              </p>
              <p v-if="hasFile" class="font-bold text-red-400">
                Upload file {{ file.name }}
              </p>
              </div>
       </form>


      <div class="feedback" v-if="isComplete || isFailed || isSuccess">

     <!--SUCCESS-->
      <div v-if="isComplete || isSuccess" class="success">
        <span class="uploaded-msg" v-if="isComplete"> <i class="icon fa-check"/> 1 file has been uploaded</span>

        <iframe v-if="extension != 'docx'" v-bind:src="pathUrl" width="99%" height="410px" overflow='hidden'  />
        <div class="word-doc" v-if="extension == 'docx'">
          <h3>Can not display a Word document preview. Please use PDF files to enable content previews.</h3>
          <i class="icon fa fa-file-word-o" aria-hidden="true"></i>

        </div>
      </div>
      <!--FAILED-->
      <div v-if="isFailed">
        <h3>Uploaded failed.</h3>
        <pre>{{ uploadError }}</pre>
      </div>
    </div>

  </div>
</template>

<script>
import { fileResourceMixin } from "@/mixins/file-ResourceMixin.js";

import { mapGetters } from "vuex";

const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_FAILED = 3;

export default {
  name: "data_upload",
  mixins: [fileResourceMixin],
  props: ["currentFile"],
  data() {
    return {
      uploadError: null,
      currentStatus: null,
      uploadFieldName: "photos",
      loading: false,
      pathUrl: null,
      extension: null,
            file: {},
    };
  },
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
    displayFileName() {
      let str = this.currentFile;
      return str.substring(str.lastIndexOf("/") + 1);
    },
    hasFile() {
      return this.file.name != undefined && this.file.name.length > 3;
    },
    circle() {
      return ((this.completedPercentage / 100) * 100 * Math.PI) + ',9999';
    },
  },
  created() {
    if (this.currentFile.length > 0) {
      this.preload();
    }
  },
  methods: {
    preload() {
      this.loading = true;
      this.loadDocument(this.currentFile);
    },
    clear() {
      this.refreshUpload();
      this.$emit("file", "");
    },
    loadDocument(path) {
      var ext = path.split(".").pop();
      this.extension = ext;

      if (ext == "docx") {
        this.loading = false;
      } else {
        this.getLessonDocument(path)
          .then(f => {
            this.loading = false;
            this.pathUrl = f;
            this.currentStatus = STATUS_SUCCESS
          })
          .catch(err => {
            console.log(err);
            this.currentStatus = STATUS_FAILED;
          });
      }
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      console.log(this.file);

      let formData = new FormData();
      formData.append("file", this.file);
      const result = this.uploadDocument("teaching", formData, "");

      result.then((response) => {
        console.log(this.remoteName)
        this.$emit("file", this.remoteName);
        this.loadDocument(this.remoteName);
      });
    },
    openBrowse() {
      if ((this.currentStatus = STATUS_INITIAL)) {
        this.clear();
      } else {
        var elem = this.$refs.upBtn;
      }
    }
  },
  mounted() {
    this.refreshUpload();
  }
};
</script>

<style scoped>

.feedback {
  height: 340px !important;
  padding-left: 20px;
  padding-top: 0px;
}

.container .input-file {
  opacity: 0;
  width: 41%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.success {
  overflow-x: hidden !important;
}

.success iframe {
  padding: 0px;
  marging: 0px;
}

.word-doc {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 80px;
  color: #373b3c;
  text-align: center;
}

.word-doc .icon {
  padding-top: 17px;
  font-size: 74px;
  opacity: 0.6;
}

.uploaded-msg {
  font-weight: 700;
  color: #7fc6a4;
}
</style>
